// extracted by mini-css-extract-plugin
export default {"contentContainer":"contact_contentContainer__8i9Ab","pageTitle":"contact_pageTitle__RYadc","articleIntro":"contact_articleIntro__UPtE4"};